import { getTags, getTagGroup, getCyoPromos } from '../../api/api';
import { spicyTagsBySpicyLevel } from '../../utils/utils';
import * as actions from './actions';

export const togglePdpModal = (product) => {
  return (dispatch) => {
    dispatch({
      product,
      type: actions.TOGGLE_PDP_MODAL,
    });
  };
};
